// extracted by mini-css-extract-plugin
export default {"inputContainer":"SplitterBranchInput_inputContainer__dFJ8-","input":"SplitterBranchInput_input__4oqtp","addButton":"SplitterBranchInput_addButton__0bjAZ"};